import { Autocomplete, TextField, useMediaQuery } from "@mui/material";
import { ArrowVertical } from "icons";
import { SelectItem } from "types/Common";

type AutoInputCompleteProps = {
  id?: string;
  label?: string;
  options: SelectItem[];
  onChange?: (value: string | null) => void;
};

export const AutoInputComplete = ({ id, label, options, onChange }: AutoInputCompleteProps) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Autocomplete
      id={id}
      onChange={(event, value) => onChange && onChange(value ? value.value.toString() : null)}
      getOptionLabel={option => option.label}
      disablePortal
      popupIcon={<ArrowVertical />}
      options={options}
      sx={{ width: isMobile ? "100%" : 190 }}
      renderInput={params => <TextField {...params} variant="standard" label={label} />}
    />
  );
};
